import React from 'react';

function FlashCards() {
    return (
        <div>
            <h2>Flash Cards</h2>
            <p>Interactive flash cards will be here soon!</p>
        </div>
    );
}

export default FlashCards;